function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { renderless, api } from "@opentiny/vue-renderless/image-viewer/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import { directive } from "@opentiny/vue-common";
import { isObject } from "@opentiny/vue-renderless/common/type";
var TinyTouch = /* @__PURE__ */ function() {
  function TinyTouch2(element, tinyBinding, type) {
    var that = this;
    that.element = element;
    that.tinyBinding = tinyBinding;
    that.touchType = type;
    that.tinyVueTouches = {
      x: 0,
      y: 0
    };
    that.tinyVueMoves = true;
    that.tinyVueLeave = true;
    that.tinyLongTouch = true;
    that.tinyVueCallBack = isObject(tinyBinding.value) ? tinyBinding.value.fn : tinyBinding.value;
    that.element.addEventListener("touchstart", function(e) {
      that.start(e);
    });
    that.element.addEventListener("touchend", function(e) {
      that.end(e);
    });
    that.element.addEventListener("touchmove", function(e) {
      that.move(e);
    });
  }
  var _proto = TinyTouch2.prototype;
  _proto.start = function start(e) {
    var _this = this;
    if (e.touches >= 2) {
      return;
    }
    this.tinyVueMoves = true;
    this.tinyVueLeave = true;
    this.tinyLongTouch = true;
    this.tinyVueTouches = {
      x: e.changedTouches[0].pageX,
      y: e.changedTouches[0].pageY
    };
    this.time = setTimeout(function() {
      if (_this.tinyVueLeave && _this.tinyVueMoves) {
        _this.touchType == "longtap" && _this.tinyVueCallBack(_this.tinyBinding.value, e);
        _this.tinyLongTouch = false;
      }
    }, 1e3);
  };
  _proto.end = function end(e) {
    if (e.touches >= 2) {
      return;
    }
    var disX = e.changedTouches[0].pageX - this.tinyVueTouches.x;
    var disY = e.changedTouches[0].pageY - this.tinyVueTouches.y;
    clearTimeout(this.time);
    if (Math.abs(disX) > 10 || Math.abs(disY) > 100) {
      this.touchType == "swipe" && this.tinyVueCallBack(this.tinyBinding.value, e);
      if (Math.abs(disX) > Math.abs(disY)) {
        if (disX > 10) {
          this.touchType == "swiperight" && this.tinyVueCallBack(this.tinyBinding.value, e);
        }
        if (disX < -10) {
          this.touchType == "swipeleft" && this.tinyVueCallBack(this.tinyBinding.value, e);
        }
      } else {
        if (disY > 10) {
          this.touchType == "swipedown" && this.tinyVueCallBack(this.tinyBinding.value, e);
        }
        if (disY < -10) {
          this.touchType == "swipeup" && this.tinyVueCallBack(this.tinyBinding.value, e);
        }
      }
    } else {
      if (this.tinyLongTouch && this.tinyVueMoves) {
        this.touchType == "tap" && this.tinyVueCallBack(this.tinyBinding.value, e);
        this.tinyVueLeave = false;
      }
    }
  };
  _proto.move = function move() {
    this.tinyVueMoves = false;
  };
  return TinyTouch2;
}();
var mapDirective = function mapDirective2() {
  var deactives = {};
  var names = ["tap", "swipe", "swipeleft", "swiperight", "swipedown", "swipeup", "longtap"];
  names.forEach(function(name) {
    deactives[name] = directive({
      vTouch: {
        bind: function bind(el, tinyBinding) {
          new TinyTouch(el, tinyBinding, name);
        }
      }
    }).vTouch;
  });
  return deactives;
};
var touchDeactives = mapDirective();

import { IconClose, IconChevronLeft, IconChevronRight, IconZoomOut, IconZoomIn, IconFullscreen, IconMinscreen, IconRepeat, IconRefres, IconDel, IconDownload } from "@opentiny/vue-icon";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

import "@opentiny/vue-renderless/common/type";
var __vue2_script = defineComponent({
  props: [].concat(props, ["urlList", "zIndex", "onSwitch", "onClose", "showIndex"]),
  emits: ["update:preview-visible", "close", "change", "newImageList"],
  components: {
    IconClose: IconClose(),
    IconChevronLeft: IconChevronLeft(),
    IconChevronRight: IconChevronRight(),
    IconZoomOut: IconZoomOut(),
    IconZoomIn: IconZoomIn(),
    IconFullscreen: IconFullscreen(),
    IconMinscreen: IconMinscreen(),
    IconRepeat: IconRepeat(),
    IconRefres: IconRefres(),
    IconDel: IconDel(),
    IconDownload: IconDownload()
  },
  directives: _extends({}, touchDeactives),
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("transition", {
    attrs: {
      "name": "viewer-fade"
    }
  }, [_c("div", {
    staticClass: "fixed inset-0 hidden sm:block z-10",
    on: {
      "mousewheel": function mousewheel($event) {
        $event.preventDefault();
      }
    }
  }, [_c("div", {
    staticClass: "absolute w-full h-full top-0 left-0 sm:opacity-30 bg-black"
  }), _c("span", {
    staticClass: "flex absolute items-center justify-center rounded-full box-border select-none top-20 right-20 bottom-10 text-xl cursor-pointer w-8 h-8 hover:bg-color-text-primary active:bg-color-border fill-color-bg-1 bg-color-border",
    on: {
      "click": _vm.hide
    }
  }, [_c("icon-close", {
    staticClass: "fill-color-bg-1 cursor-pointer"
  })], 1), !_vm.state.isSingle ? [_c("span", {
    staticClass: "absolute flex items-center justify-center rounded-full box-border select-none top-1/2 w-8 h-8 bg-color-border -translate-y-1/2 left-20 hover:bg-color-text-primary active:bg-color-border fill-color-bg-1 cursor-pointer",
    class: {
      "is-disabled": !_vm.state.infinite && _vm.state.isFirst
    },
    on: {
      "click": _vm.prev
    }
  }, [_c("icon-chevron-left")], 1), _c("span", {
    staticClass: "absolute flex items-center justify-center rounded-full box-border select-none top-1/2 w-8 h-8 -translate-y-1/2 right-20 indent-0.5 hover:bg-color-text-primary active:bg-color-border fill-color-bg-1 bg-color-border cursor-pointer",
    class: {
      "is-disabled": !_vm.state.infinite && _vm.state.isLast
    },
    on: {
      "click": _vm.next
    }
  }, [_c("icon-chevron-right")], 1)] : _vm._e(), _c("div", {
    staticClass: "z-10 absolute inline-flex items-center justify-center box-border select-none left-1/2 bottom-12 -translate-x-1/2 w-60 h-10 px-4 opacity-50 bg-black rounded-[1.375rem] cursor-pointer"
  }, [_c("div", {
    staticClass: "w-full h-full text-justify cursor-default text-2xl flex items-center justify-between fill-color-bg-1"
  }, [_c(_vm.state.mode.icon, {
    tag: "component",
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.toggleMode
    }
  }), _c("icon-zoom-out", {
    staticClass: "cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.handleActions("zoomOut");
      }
    }
  }), _c("icon-zoom-in", {
    staticClass: "cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.handleActions("zoomIn");
      }
    }
  }), _c("icon-refres", {
    staticClass: "cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.handleActions("clocelise");
      }
    }
  }), _c("icon-repeat", {
    staticClass: "cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.handleActions("anticlocelise");
      }
    }
  }), _c("icon-del", {
    staticClass: "cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.handleActions("delImage");
      }
    }
  }), _c("a", {
    staticClass: "cursor-pointer inline-flex fill-color-bg-1",
    attrs: {
      "href": "" + _vm.state.currentImg,
      "target": "_blank",
      "download": ""
    }
  }, [_c("icon-download")], 1)], 1)]), _vm.showIndex ? _c("div", {
    staticClass: "z-10 absolute flex items-center justify-center box-border left-1/2 -translate-x-1/2 px-4 bottom-5"
  }, [_c("span", {
    staticClass: "h-4.5 inline-flex items-center text-color-text-primary"
  }, [_vm._v(" " + _vm._s(_vm.state.index + 1 + "/" + _vm.urlList.length) + " ")])]) : _vm._e(), _c("div", {
    staticClass: "z-10 flex w-full h-full items-center justify-center"
  }, [_vm._l(_vm.urlList, function(url, i) {
    return [i === _vm.state.index ? _c("img", {
      key: url,
      ref: "img_" + i,
      refInFor: true,
      style: _vm.state.imgStyle,
      attrs: {
        "src": _vm.state.currentImg
      },
      on: {
        "error": _vm.handleImgError,
        "mousedown": _vm.handleMouseDown,
        "load": _vm.handleImgLoad
      }
    }) : _vm._e()];
  })], 2)], 2)]), _c("transition", {
    attrs: {
      "name": "viewer-fade"
    }
  }, [_c("div", {
    staticClass: "w-screen h-screen fixed top-0 left-0 sm:hidden z-50"
  }, [_c("div", {
    staticClass: "absolute w-full h-full top-0 left-0 bg-black"
  }), _c("div", {
    staticClass: "w-screen h-11 text-color-bg-1 absolute leading-[2.75rem] text-center"
  }, [_c("a", {
    staticClass: "!text-inherit",
    attrs: {
      "href": "javascript:history.go(-1)"
    }
  }, [_c("IconChevronLeft", {
    staticClass: "fill-color-bg-1 absolute w-4 h-4 top-3.5 left-3"
  }), _vm._v("图片预览")], 1)]), _c("div", {
    directives: [{
      name: "swipeleft",
      rawName: "v-swipeleft",
      value: _vm.swipeLeft,
      expression: "swipeLeft"
    }, {
      name: "swiperight",
      rawName: "v-swiperight",
      value: _vm.swipeRight,
      expression: "swipeRight"
    }],
    staticClass: "inset-0 fixed"
  }, [_vm.showIndex ? _c("div", {
    staticClass: "absolute flex items-center justify-center box-border left-1/2 -translate-x-1/2 px-4 bottom-12"
  }, [_c("span", {
    staticClass: "h-4.5 inline-flex items-center text-color-bg-1"
  }, [_vm._v(" " + _vm._s(_vm.state.index + 1 + "/" + _vm.urlList.length) + " ")])]) : _vm._e(), _c("div", {
    ref: "canvasBox",
    staticClass: "w-full h-full"
  }, [_c("div", {
    staticClass: "h-full flex items-center justify-center w-[69.375rem]",
    style: {
      "width": _vm.state.iamgeAllWidth + "px",
      "transition-duration": _vm.state.imageTransition + "ms",
      transform: "translateX(" + _vm.state.imageTransformSize + "px)"
    }
  }, [_vm._l(_vm.urlList, function(url, i) {
    return _c("div", {
      key: i,
      ref: "viewerItem",
      refInFor: true,
      staticClass: "relative shrink h-full w-[23.125rem]",
      style: Object.assign({
        width: _vm.state.imageItemWidth + "px"
      }, i === _vm.state.index ? _vm.state.imgStyle : "")
    }, [_c("div", {
      staticClass: "absolute top-0 left-0 right-0 bottom-0 text-center transition-transform inline-block duration-300"
    }, [i === _vm.state.index ? _c("img", {
      key: url,
      ref: "img_" + i,
      refInFor: true,
      class: ["block w-full h-full object-contain", {
        "object-fill": _vm.state.fullScreen
      }],
      style: _vm.state.imgStyle,
      attrs: {
        "src": _vm.state.currentImg
      },
      on: {
        "mousedown": _vm.handleMouseDown,
        "error": _vm.handleImgError,
        "load": _vm.handleImgLoad,
        "touchstart": _vm.touchstart,
        "touchmove": _vm.touchmove,
        "touchend": _vm.touchend
      }
    }) : _vm._e()])]);
  })], 2)])])])])], 1);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
